import {
  CreateGameRequest,
  GameCardDto,
  UpdateGameRequest,
} from "../../api-client";
import { GameCardState } from "../states/ConstructorPageStates/GameCardState";
import { DEFAULT_GAME_IMAGE } from "../constants/constants";

export class GameCardMapper {
  public static toGameCardState(gameCardDto: GameCardDto): GameCardState {
    return {
      apiId: gameCardDto.id ? gameCardDto.id : null,
      name: gameCardDto.name ? gameCardDto.name : "",
      image: gameCardDto.thumbnail ? gameCardDto.thumbnail : DEFAULT_GAME_IMAGE,
      author: gameCardDto.creatorName ? gameCardDto.creatorName : "",
      playersTodayCount: gameCardDto.playersToday
        ? gameCardDto.playersToday
        : 0,
      playersAllCount: gameCardDto.playersTotal ? gameCardDto.playersTotal : 0,
      favoriteCount: gameCardDto.favourited ? gameCardDto.favourited : 0,
      tags: gameCardDto.tags ? gameCardDto.tags : [],
    };
  }

  public static toGameCardStates(gameCardDtos: GameCardDto[]): GameCardState[] {
    return gameCardDtos.map((gameCardDto) => {
      return {
        apiId: gameCardDto.id ? gameCardDto.id : null,
        name: gameCardDto.name ? gameCardDto.name : "",
        image: gameCardDto.thumbnail
          ? gameCardDto.thumbnail
          : DEFAULT_GAME_IMAGE,
        author: gameCardDto.creatorName ? gameCardDto.creatorName : "",
        playersTodayCount: gameCardDto.playersToday
          ? gameCardDto.playersToday
          : 0,
        playersAllCount: gameCardDto.playersTotal
          ? gameCardDto.playersTotal
          : 0,
        favoriteCount: gameCardDto.favourited ? gameCardDto.favourited : 0,
        tags: gameCardDto.tags ? gameCardDto.tags : [],
      };
    });
  }

  public static toCreateGameRequest(
    gameCardState: GameCardState
  ): CreateGameRequest {
    return {
      name: gameCardState.name,
      thumbnail: gameCardState.image,
      collectionName: gameCardState.name,
    };
  }

  public static toCreateGameRequests(
    gameCardStates: GameCardState[]
  ): CreateGameRequest[] {
    return gameCardStates.map((gameCardState) => {
      return {
        name: gameCardState.name,
        thumbnail: gameCardState.image,
      };
    });
  }

  public static toUpdateGameRequest(
    gameCardState: GameCardState
  ): UpdateGameRequest {
    return {
      newName: gameCardState.name,
      newThumbnail: gameCardState.image,
    };
  }

  public static toUpdateGameRequests(
    gameCardStates: GameCardState[]
  ): UpdateGameRequest[] {
    return gameCardStates.map((gameCardState) => {
      return {
        newName: gameCardState.name,
        newThumbnail: gameCardState.image,
      };
    });
  }
}
